import {
  GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS,
  RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_SUCCESS,
  GET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_SUCCESS,
  LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  virtualCart: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS: {
      const data = { ...state.data };

      data[action.payload.id].items = action.payload.items;

      return {
        ...state,
        data,
        isFetching: false
      };
    }

    case GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS: {
      const data = { ...state.data };

      data[action.payload.id] = {
        ...data[action.payload.id],
        processingStatus: action.payload.processingStatus
      };

      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }

    case RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_SUCCESS: {
      const virtualCart = { ...state.virtualCart };

      virtualCart[action.payload.id] =
        state.data[action.payload.id].virtualCart;

      virtualCart[action.payload.id].virtualTest = {
        isSuccess: true,
        missingCount: 0,
        missingTotal: 0
      };
      return {
        ...state,
        virtualCart,
        isFetching: false
      };
    }
    case GET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_SUCCESS: {
      const virtualCart = { ...state.virtualCart };
      virtualCart[action.clubSubscriptionShipmentId] = action.payload;
      return {
        ...state,
        virtualCart,
        isFetching: false
      };
    }
    case LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS: {
      const data = { ...state.data };

      action.payload.clubSubscriptionShipments.forEach(
        (clubSubscriptionShipment) => {
          data[clubSubscriptionShipment.id] = clubSubscriptionShipment;
        }
      );
      return {
        ...state,
        data,
        isFetching: false
      };
    }

    case GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS: {
      const virtualCart = { ...state.virtualCart };
      const data = { ...state.data };

      // // we need to store initialVirtualCart in order to discard changes to default one
      data[action.clubSubscriptionShipmentId].virtualCart = action.payload;

      virtualCart[action.clubSubscriptionShipmentId] = action.payload;
      virtualCart[action.clubSubscriptionShipmentId].virtualTest = {
        isSuccess: true,
        missingCount: 0,
        missingTotal: 0
      };
      return {
        ...state,
        // data,
        virtualCart,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
